export default {
  "memberStatistics": "Member statistics",
  "distributionByMemberTypeAndLevel": "Distribution by member type and level, using the same criteria as the member list",
  "viewMembers": "View members",
  "byMemberType": "By member type",
  "totalMembers": "Total members",
  "change": "Change",
  "vsLastMonth": "vs. last month",
  "noMemberTypeData": "No member type data",
  "share": "Share",
  "byMemberLevel": "By member level",
  "noMemberLevelData": "No member level data",
  "revenue": "Revenue",
  "membershipFeeAndEventRegistrationRevenue": "Membership fee and event registration revenue over the last 12 months",
  "viewPaymentRecords": "View payment records",
  "revenueBreakdown": "Revenue breakdown",
  "noRecordedRevenue": "No recorded revenue",
  "revenueOverTheLast12Months": "Revenue over the last 12 months",
  "membershipFees": "Membership fees",
  "eventRegistration": "Event registration",
  "newMembersThisYear": "New members this year",
  "newMembersThisMonth": "New members this month",
  "noPendingApplications": "No pending applications",
  "activeMemberRate": "Active member rate",
  "requiresRecentMiniProgramLoginData": "Requires recent mini-program login data",
  "digitalMembershipCardsIssued": "Digital membership cards issued",
  "membershipCardsAreNotAvailableYet": "Membership cards are not available yet",
  "totalRevenue": "Total revenue",
  "includesMembershipFeesAndEventRegistrations": "Includes membership fees and event registrations",
  "membershipFeeRevenue": "Membership fee revenue",
  "collectedThisYear": "Collected this year",
  "outstandingMembershipFees": "Outstanding membership fees",
  "noOutstandingPayments": "No outstanding payments",
  "cNY10k": "CNY ×10k",
  "cNY": "CNY",
  "couldNotLoadTheDashboard": "Could not load the dashboard",
  "membershipFeeSettings": "Membership fee settings",
  "renewalManagement": "Renewal management",
  "feeDue": "💡 Fee due =",
  "baseAnnualFeeForThePosition": "Base annual fee for the position",
  "termMultiplier": "Term multiplier",
  "memberTypeMultiplier": "Member type multiplier",
  "yearsInTheBillingCycle": "Years in the billing cycle",
  "midTermEnrollmentIsProratedBy": "; mid-term enrollment is prorated by",
  "remainingMonths": "remaining months",
  "currentTerm": ". Current term:",
  "exampleACorporateMemberServingAs": "Example: a corporate member serving as president (base ¥8,000), term 4 multiplier 1.0, 3-year term → 8000 × 1.0 × 1.2 × 3 =",
  "perTermThisPageManagesPricing": "per term. This page manages pricing rules only;",
  "amountsDuePerPeriodPaidOutstanding": "amounts due per period, paid/outstanding fees, renewals and reminders",
  "areAvailableIn": "are available in",
  "changesHere": ". Changes here",
  "takeEffectImmediatelyWithoutASeparate": "take effect immediately without a separate save",
  "feeSettingTabs": "Fee setting tabs",
  "terms": "Terms",
  "addTerm": "Add term",
  "termStatusIsDeterminedFrom": "Term status is determined from",
  "theTermStartEndDates": "the term start/end dates",
  "andTheCurrentDate": "and the current date:",
  "active": "Active",
  "termsAreIncludedInCurrentBilling": "terms are included in current billing. Ended terms are archived and upcoming terms are not effective yet. The term end date is the membership expiry date. Today:",
  "termName": "Term name",
  "termDatesExpiry": "Term dates / expiry",
  "term": "Term",
  "years": "years ·",
  "expires": "expires",
  "multiplier": "Multiplier",
  "termStatus": "Term status",
  "billing": "Billing",
  "actions": "Actions",
  "edit": "Edit",
  "delete": "Delete",
  "noTermsYetAddATerm": "No terms yet. Add a term.",
  "total": "Total",
  "records": "records",
  "positionsAndBaseAnnualFees": "Positions and base annual fees",
  "addPosition": "Add position",
  "theBaseAnnualFeeIsThe": "The base annual fee is the standard annual amount for a position. Term billing covers the term duration; annual billing covers one year.",
  "positionName": "Position name",
  "baseAnnualFee": "Base annual fee",
  "billingFormula": "Billing formula",
  "termMultiplierTypeMultiplier": "× term multiplier × type multiplier",
  "cycle": "Cycle",
  "status": "Status",
  "noPositionsYetAddAPosition": "No positions yet. Add a position.",
  "memberTypeRates": "Member type rates",
  "editMemberTypeRates": "Edit member type rates",
  "useEditMemberTypeRatesTo": "Use Edit member type rates to set multipliers for all member types. Manage member types and enrollment fields on the Membership applications page.",
  "memberType": "Member type",
  "baseAnnualFeeTermMultiplier": "Base annual fee × term multiplier ×",
  "examplePerPeriod": "Example per period",
  "description": "Description",
  "midTermEnrollment": "Mid-term enrollment",
  "chooseHowToChargeMembersWho": "Choose how to charge members who join after the term starts. Proration can have a threshold: joining within the first few months may still require the full fee.",
  "changesTakeEffectImmediately": "Changes take effect immediately",
  "prorateByRemainingMonths": "Prorate by remaining months",
  "feeDueFeePerPeriodRemaining": "Fee due = fee per period × remaining months at enrollment ÷ total term months",
  "prorationAppliesAfter": "Proration applies after",
  "monthsOfTheTermHaveElapsed": "months of the term have elapsed",
  "beforeTheThresholdChargeTheFull": "Before the threshold, charge the full fee. Enter 1–60 months; the default is 6 months.",
  "fixedAmount": "Fixed amount",
  "chargeTheSameAmountForMid": "Charge the same amount for mid-term enrollment regardless of the remaining months",
  "fixedMidTermEnrollmentFee": "Fixed mid-term enrollment fee: ¥",
  "applyThisFeeWhenJoiningAt": "Apply this fee when joining at least one month after the term starts. Current amount:",
  "examples": "Examples:",
  "forAPresidentInTerm4": "For a president in term 4 (2025-07-01 – 2028-06-30)",
  "joinInTheFirstMonth2025": "· Join in the first month (2025-07-01) →",
  "fullFee": "(full fee)",
  "joinBeforeTheThreshold202512": "· Join before the threshold (2025-12-01, 5 months elapsed) →",
  "noProrationFullFee": "(no proration; full fee)",
  "joinOnTheThresholdDate2026": "· Join on the threshold date (2026-01-01) →",
  "prorated29Of36MonthsRemaining": "(prorated; 29 of 36 months remaining)",
  "regularEnrollmentFullFee": "(regular enrollment; full fee)",
  "joinAfter8Months202603": "· Join after 8 months (2026-03-01) →",
  "fixedAmountRegardlessOfRemainingMonths": "(fixed amount, regardless of remaining months)",
  "thisPricingRuleWillBeConfigured": "This pricing rule will be configured in a later step",
  "feeCalculator": "Fee calculator",
  "calculateTheFeePerPeriodBy": "Calculate the fee per period by member type, position and term, including mid-term proration. See Renewal management for bulk billing and renewals.",
  "selectAMemberType": "Select a member type",
  "position": "Position",
  "selectAPosition": "Select a position",
  "enrollmentTerm": "Enrollment term",
  "selectAnEnrollmentTerm": "Select an enrollment term",
  "midTermEnrollment1": "Mid-term enrollment (",
  "currentRule": "Current rule:",
  "selectEnrollmentDate": "Select enrollment date",
  "calculateFee": "Calculate fee",
  "selectAMemberTypePositionAnd": "Select a member type, position and term, then click Calculate fee",
  "termMultiplier2": "× term multiplier",
  "typeMultiplier": "× type multiplier",
  "year": "/ year",
  "billingCycle": "Billing cycle:",
  "yearsFeePerPeriod": "years) → fee per period",
  "membershipExpires": "Membership expires:",
  "term3": "(term",
  "eGTerm6": "e.g. Term 6",
  "termStartDate": "Term start date",
  "termEndDateMembershipExpiry": "Term end date (membership expiry)",
  "termYearsCalculatedFromDates": "Term years (calculated from dates)",
  "termStatusAutomatic": "Term status (automatic)",
  "notes": "Notes",
  "optionalEGFoundingTermProposed": "Optional, e.g. founding term / proposed term",
  "enterTheTermEndDateTo": "Enter the term end date to determine membership expiry",
  "billingFormulaBaseAnnualFee": "Billing formula: base annual fee",
  "presidentTermMultiplier": "(president) × term multiplier",
  "typeMultiplier12CorporateMember": "× type multiplier 1.2 (corporate member) ×",
  "years4": "years",
  "estimatedFeePerPeriod": "→ estimated fee per period ≈",
  "years5": "years)",
  "termStatusIsDeterminedAutomaticallyFrom": "Term status is determined automatically from its dates and today. Only active terms are included in current billing.",
  "cancel": "Cancel",
  "save": "Save",
  "eGPresident": "e.g. President",
  "baseAnnualFeeCNY": "Base annual fee (CNY)",
  "billingCycle6": "Billing cycle",
  "perTerm": "Per term",
  "perYear": "Per year",
  "displayOrder": "Display order",
  "enabledStatus": "Enabled status",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "optionalEGHighestDecisionMaking": "Optional, e.g. highest decision-making position",
  "feeBaseAnnualFee": "Fee = base annual fee",
  "termMultiplierMemberTypeMultiplierCycle": "× term multiplier × member type multiplier × cycle years",
  "term4Multiplier13Years": "→ Term 4 (multiplier 1 · 3 years · expires 2028-06-30):",
  "feePositionBaseAnnualFeeTerm": "Fee = position base annual fee × term multiplier × member type multiplier × cycle years. Set all member type multipliers here; they take effect together when saved.",
  "examplePresidentBaseAnnualFee8": "Example: president (base annual fee ¥8,000) × term multiplier 1 × 3 years × member type multiplier",
  "currentMultiplier": "Current multiplier",
  "newMultiplier": "New multiplier *",
  "newMultiplier7": "new multiplier",
  "multipliersMustBe0AndMay": "Multipliers must be ≥ 0 and may contain decimals. Examples update as you type. Changes take effect when saved.",
  "enterATermName": "Enter a term name",
  "selectTheTermStartDate": "Select the term start date",
  "selectTheTermEndDate": "Select the term end date",
  "enterAMultiplier": "Enter a multiplier",
  "enterAPositionName": "Enter a position name",
  "enterABaseAnnualFee": "Enter a base annual fee",
  "selectABillingCycle": "Select a billing cycle",
  "notSet": "Not set",
  "ended": "Ended",
  "upcoming": "Upcoming",
  "includedInBilling": "Included in billing",
  "archived": "Archived",
  "notYetEffective": "Not yet effective",
  "selectAMemberTypePositionAnd8": "Select a member type, position and enrollment term",
  "midTermFixedAmount": "Mid-term · fixed amount",
  "midTermProrated": "Mid-term · prorated",
  "midTermFullFee": "Mid-term · full fee",
  "couldNotLoadTerms": "Could not load terms",
  "couldNotLoadPositions": "Could not load positions",
  "couldNotLoadMemberTypes": "Could not load member types",
  "couldNotLoadMidTermEnrollment": "Could not load mid-term enrollment settings",
  "couldNotSaveMidTermEnrollment": "Could not save mid-term enrollment settings",
  "addAMemberTypeOnThe": "Add a member type on the Membership applications page first",
  "enterAValidMultiplierForEvery": "Enter a valid multiplier for every member type (0–9999.9999)",
  "memberTypeRatesUpdated": "Member type rates updated",
  "couldNotSaveMemberTypeRates": "Could not save member type rates",
  "termUpdated": "Term updated",
  "termAdded": "Term added",
  "couldNotSaveTerm": "Could not save term",
  "deleteTerm": "Delete term",
  "termDeleted": "Term deleted",
  "couldNotDeleteTerm": "Could not delete term",
  "positionUpdated": "Position updated",
  "positionAdded": "Position added",
  "couldNotSavePosition": "Could not save position",
  "deletePosition": "Delete position",
  "positionDeleted": "Position deleted",
  "couldNotDeletePosition": "Could not delete position",
  "includedInCurrentBilling": "Included in current billing",
  "archivedExcludedFromCurrentBilling": "Archived; excluded from current billing",
  "notYetEffectiveExcludedFromBilling": "Not yet effective; excluded from billing",
  "noAssociationMiniProgramInstancesAvailable": "No association mini-program instances available",
  "thisAssociationFeatureWillBeAvailable": "This association feature will be available in a later release",
  "noManageableMiniProgramInstances": "No manageable mini-program instances",
  "couldNotLoadManageableMiniProgram": "Could not load manageable mini-program instances",
  "message1": "{p0} members",
  "message2": "{p0} vs. the same period last year",
  "message3": "Includes {p0} pending applications",
  "message4": "{p1} members logged in within {p0} days",
  "message5": "{p0} cards",
  "message6": "{p0}% of registered members",
  "message7": "{p0}% share",
  "message8": "Total for {p0}",
  "message9": "{p0} unpaid payments",
  "message10": "¥{p0} ×10k",
  "message11": "{p0} ({p1} – {p2} · Active)",
  "message12": "Fixed mid-term fee: {p0} ({p1} months into the term)",
  "message13": "{p0} months elapsed (threshold: {p1} months). Prorated from enrollment on {p2} to term end on {p3}: {p4} of {p5} months remaining.",
  "message14": "{p0} months elapsed, below the {p1}-month threshold. Full fee applies.",
  "message15": "Changed to {p0}",
  "message16": "Delete “{p0}”? This term will no longer be included in fee calculations.",
  "message17": "Delete “{p0}”?",
  "message18": "{p0} (base {p1} · {p2})",
  "message19": "{p0} (multiplier {p1} · {p2} years · expires {p3} · {p4})",
  "message20": "Fixed amount {p0}",
  "message21": "Prorate remaining months; threshold {p0} months",
  "message22": "Fixed amount {p0} for enrollment after the term starts",
  "message23": "Proration starts after {p0} months; full fee applies before the threshold",
  "editTerm": "Edit term",
  "editPosition": "Edit position",
  "corporateMember": "Corporate member",
  "groupMember": "Group member",
  "individualMember": "Individual member",
  "member": "Member",
  "corporateRate": "Corporate member multiplier",
  "groupRate": "Group member multiplier",
  "individualRate": "Individual member multiplier",
  "feeFormula": "💡 Fee due = position base annual fee × term multiplier × member type multiplier × billing cycle years. Mid-term enrollment is prorated by remaining months. Current term: {term}.",
  "ruleExample": "Example: a corporate member serving as president (base ¥8,000), term 4 multiplier 1.0, 3-year term → 8000 × 1.0 × 1.2 × 3 = ¥28,800 per term. This page manages pricing rules. See Renewal management for amounts due, paid/outstanding fees, renewals and reminders. Changes here take effect immediately without a separate save.",
  "termHelp": "Term status is determined automatically from the term dates and today. Active terms are included in current billing; ended terms are archived and upcoming terms are not yet effective. The term end date is the membership expiry date. Today: {date}.",
  "resultFormula": "Base annual fee {base} × term multiplier {term} × type multiplier {type} = {annual} / year\nBilling cycle: {cycle} ({years} years) → fee per period {full}",
  "memberExpiry": "Membership expires: {end} (term {start}–{end})",
  "termExample": "Example: base annual fee ¥8,000 (president) × term multiplier {coefficient} × type multiplier 1.2 (corporate member) × {years} years → estimated fee per period ¥{amount}.",
  "positionExample": "Fee = base annual fee {base} × term multiplier × member type multiplier × cycle years\n→ Term 4 (multiplier 1 · 3 years · expires 2028-06-30): {amount}"
}
